<template>
  <div class="reg-auth-forgot__bottom">
    <UiBtn
      class="reg-auth-forgot__button"
      :data-id="isPageAuth ? 'register-footer-link' : 'login-footer-link'"
      :text="textBtn"
      color="transparent"
      icon="common/user-tick"
      v-bind="isPageAuth ? {} : { dataGtmId: GTM_REG.ID.ga_registration_click_btn_login }"
      @click="redirectTo"
    />
  </div>
</template>

<script>
import { AuthBy } from '@/util/composables/useLocalStorage'
import { GTM_REG } from '@/constants/gtm'

export default {
  name: 'RegAuthToggle',
  data() {
    return {
      GTM_REG,
    }
  },
  computed: {
    textBtn() {
      return this.isPageAuth
        ? this.$t('regAuthForgot.redirect.authBtn')
        : this.$t('regAuthForgot.redirect.regBtn')
    },
    pageName() {
      return this.$route.query.bigModal
    },
    isPageAuth() {
      return this.pageName === 'auth'
    },
  },
  methods: {
    redirectTo() {
      if (this.$route.path.includes('/registration')) {
        this.$router.push({
          path: this.$paths.home,
          query: { bigModal: 'auth', bigModalTab: AuthBy.value || 'phone' },
        })
      }
      else {
        this.isPageAuth
          ? this.$newModal.changeQueryParam('bigModal', 'registration')
          : this.$newModal.openAuthWithLastMethod()
      }
    },
  },
}
</script>

<style lang="scss" src="./style.scss"></style>
